export default __webpack_public_path__ + "7c7af1055248974a4a083aa70a9f160d.png";